<template>
  <div>
    <alertaMensaje :snackbar="mostrarSnackbar" :mensajeAlertaData="mensajeAlerta" @update-snackbar="hideSnackbar">
    </alertaMensaje>

    <v-card elevation="1" outlined>
      <v-tabs background-color="#01579b" mr-5 dark color="#ffbc00" v-model="tab">
        <v-tab>
          <v-icon>mdi-message-draw</v-icon>
          &nbsp;Redactar mensaje
        </v-tab>
        <v-tab :style="{ display: datoLogin.webmaster == 1 ? 'flex' : 'none' }">
          <v-icon>mdi-whatsapp</v-icon>
          &nbsp; Redactar mensaje de Whatsapp
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item>
          <v-toolbar flat dense>
            <span>{{ titulo }}</span>
          </v-toolbar>
          <v-divider></v-divider>
          <v-card-text>
            <v-form ref="formNuevoMensaje" lazy-validation>
              <v-row>
                <v-col cols="11">
                  <!-- chips 
                        small-chips
                        -->

                  <v-autocomplete dense v-model="mensaje.destinatarios" :items="items" :loading="isLoading"
                    :search-input.sync="buscarDestinatarios" color="primary" hide-no-data hide-selected clearable
                    deletable-chips multiple item-text="Description" item-value="id" label="Destinatarios"
                    placeholder="Buscar destinatarios" :rules="rulesDestinatarios"></v-autocomplete>
                </v-col>
                <v-col cols="6">
                  <v-text-field v-model="mensaje.asunto" dense label="Asunto" :rules="rulesAsunto"
                    hide-details="auto" ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-file-input v-model="mensaje.adjuntos" dense chips multiple accept="*/*"
                    label="Adjuntar archivo"></v-file-input>
                </v-col>
                <v-col cols="12">
                  <ckeditor v-model="mensaje.cuerpo" :config="editorConfig" @input="onEditorInput"></ckeditor>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <!-- :disabled="mensaje.cuerpo == ''" -->
            <v-btn class="btn_block_style2" dark @click="enviarMensaje()" :loading="enviando">Enviar</v-btn>
            <v-btn class="btn_style3" dark @click="cancelEmail()">Cancelar</v-btn>
          </v-card-actions>
        </v-tab-item>

        <v-tab-item>
          <v-card flat>
            <v-card-text>
              <v-row>
                <v-col cols="6">
                  <h4>
                    <v-icon color="green darken-2" dark>mdi-whatsapp</v-icon>
                    ENVÍA UN MENSAJE A WHATSAPP
                  </h4>
                </v-col>

                <v-col cols="6">
                  <div class="text-center">
                    <v-menu v-model="menu" :close-on-content-click="false">
                      <!-- Se ocultó por un requerimiento #id Open proyect-> #1040 -->
                      <!-- <template v-slot:activator="{ on, attrs }">
                        <v-btn color="warning" dark v-bind="attrs" v-on="on">
                          Establecer Número Manual
                        </v-btn>
                      </template> -->

                      <v-card class="border-top primary">
                        <v-list>
                          <v-list-item>
                            <v-list-item-avatar>
                              <img
                                src="https://png.pngtree.com/png-vector/20221018/ourmid/pngtree-whatsapp-phone-icon-png-image_6315989.png" />
                            </v-list-item-avatar>

                            <v-list-item-content>
                              <v-text-field class="classNM" type="number" dense v-model="NumeroManual"
                                label="Numero Móvil"></v-text-field>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>
                      </v-card>
                    </v-menu>
                  </div>
                </v-col>
              </v-row>
              <v-form ref="formWhatsapp" v-model="valid" lazy-validation>
                <v-row>
                  <v-col cols="9">
                    <v-autocomplete dense prepend-icon="mdi-account-outline" v-model="numeroDestino"
                      :items="itemsDestinatariosWhatsapp" :loading="isLoading" :search-input.sync="buscarDestinatarios"
                      color="primary" hide-no-data hide-selected required clearable deletable-chips
                      item-text="Description" item-value="cel_persona" label="Destinatarios"
                      placeholder="Buscar destinatarios" :rules="rulesDestinatarios"></v-autocomplete>
                  </v-col>

                  <v-col cols="9">
                    <v-textarea clearable required prepend-icon="mdi-comment" clear-icon="mdi-close-circle"
                      label="Detalle del mensaje" v-model="MensajeAEnviar" :rules="rulesAsunto"></v-textarea>
                  </v-col>

                  <v-col cols="12" align="end">
                    <v-btn :disabled="!valid" @click="enviarWhatsapp()" color="primary">
                      <!--   <v-icon left> fa fa-paper-plane </v-icon>  #se oculto por correcion de estilo 1322-->
                      ENVIAR
                    </v-btn>

                    <v-btn @click="cancelarWhatsapp()" class="ml-2" color="error">
                      <!--  <v-icon left> mdi-close </v-icon>  #se oculto por correcion de estilo 1322 -->
                      CANCELAR
                    </v-btn>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
    <v-snackbar v-model="snackbarGlobal" :color="colorsnackbarGlobal" multi-line :timeout="timeout" top>
      <v-layout align-center pr-4>
        <v-icon class="pr-3" dark large>mdi-alert-circle-outline</v-icon>
        <v-layout column>
          <div>
            <strong> {{ textAlertGlobal }} </strong>
          </div>
        </v-layout>
      </v-layout>
      <template v-slot:action="{ attrs }">
        <v-btn color="black" text v-bind="attrs" @click="snackbarGlobal = false">
          Cerrar
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import axios, { BUCKET_ORIGIN_SPACE } from "../../../../helpers/axios";
import cleanAxios from "axios"
import { mapMutations, mapActions } from "vuex";

export default {
  name: "NuevoMensaje",
  components: {
    alertaMensaje: () =>
      import("../../../SimuladorExamenes/components/Co-alertaMensaje.vue"),
  },
  props: {
    titulo: {
      type: String,
      default: "",
    },
    destinatarios: {
      type: Array,
      default: Array,
    },
    mensaje: {
      type: Object,
      default: Object,
    },
    borrador: {
      type: Object,
      default: Object,
    },
  },
  data: () => ({
    datoLogin: sessionStorage, // variables de sesion del usuario
    destinatariosFilter: [],
    descriptionLimit: 50,
    enviando: false,
    isLoading: false,
    editorConfig: {
      height: 120,
      extraPlugins:
        "colorbutton,font,colordialog,justify, tableresize,liststyle",
      toolbar: [
        { name: "styles", items: ["Styles", "Format", "Font", "FontSize"] },
        {
          name: "basicstyles",
          items: [
            "Bold",
            "Italic",
            "Underline",
            "Strike",
            "Subscript",
            "Superscript",
            "-",
          ],
        },
        { name: "colors", items: ["TextColor", "BGColor"] },
        ["Undo", "Redo"],
        { name: "document", items: ["Source", "-", "Preview"] },
        { name: "tools", items: ["Maximize", "ShowBlocks"] },
        "/",
        {
          name: "paragraph",
          items: [
            "NumberedList",
            "BulletedList",
            "-",
            "Outdent",
            "Indent",
            "-",
            "Blockquote",
            "CreateDiv",
            "-",
            "JustifyLeft",
            "JustifyCenter",
            "JustifyRight",
            "JustifyBlock",
          ],
        },
        { name: "links", items: ["Link", "Unlink", "Anchor"] },
        {
          name: "insert",
          items: [
            "Table",
            "HorizontalRule",
            "Smiley",
            "SpecialChar",
            "PageBreak",
            "Iframe",
          ],
        },
      ],
    },
    buscarDestinatarios: null,
    rulesAsunto: [
      (value) => !!value || "El asunto es requerido",
      (value) =>
        (value && value.length >= 3) ||
        "El asusto debe ser mayor a 3 carácteres",
    ],
    rulesDestinatarios: [
      (value) => !!value || "Debe seleccionar al menos un destinatario",
    ],

    tab: null,
    numeroDestino: "",
    MensajeAEnviar: "",
    snackbarGlobal: "",
    colorsnackbarGlobal: "green",
    timeout: 1000,
    textAlertGlobal: "",
    menu: false,
    NumeroManual: "",
    valid: true,
    mostrarSnackbar: false, //COMPONENTE ALERTA CONFIRMACION
    mensajeAlerta: "", //COMPONENTE ALERTA CONFIRMACION
    mensajeDialog: "", //COMPONENTE DIALOGO DE CONFIRMACION
  }),
  methods: {
    ...mapActions("login", ["parametroComponente"]),
    ...mapMutations("mensajeSis", ["setEnviarMens"]),
    onEditorInput(value) {
      console.log(value, "input del data editor");
      this.mensaje.cuerpo = value;
      this.$emit("post-change-mensaje", this.mensaje);
      this.$emit("reset-countdown", this.mensaje.cuerpo);
    },
    hideSnackbar(e) {
      this.mostrarSnackbar = e;
    },
    limpiarForm() {
      this.mensaje.asunto = "";
      this.mensaje.cuerpo = "";
      this.mensaje.destinatarios = [];
      this.mensaje.adjuntos = [];
      this.$refs.formNuevoMensaje.resetValidation();
    },
    cancelEmail() {
      this.limpiarForm();
      this.$emit("post-cancel-mensaje", this.mensaje);
    },
    async enviarMensaje() {
      if (this.$refs.formNuevoMensaje.validate()) {
        this.enviando = true;
        try {
          let formData = new FormData();
          formData.append("id_usuario", sessionStorage.id);
          formData.append("id_colegio", sessionStorage.id_colegio);
          formData.append("asunto", this.mensaje.asunto);
          formData.append("cuerpo", this.mensaje.cuerpo);

          for (
            let index = 0;
            index < this.mensaje.destinatarios.length;
            index++
          ) {
            formData.append("destinatarios", this.mensaje.destinatarios[index]);
            // formData.append("correos", this.mensaje.destinatarios.correo_persona[index]);
          }

          if (this.mensaje.adjuntos) {

            for (let index = 0; index < this.mensaje.adjuntos.length; index++) {
              const archivo = this.mensaje.adjuntos[index];

              formData.append("subirArchivo", archivo);
            }
          }

          const { data } = await axios.post("/inicio/mensajeria/", formData, {
            headers: { "Content-Type": "multipart/form-data" },
          });

          this.savenotif();
          this.setEnviarMens({
            tipo: data.messageT,
            mensaje: `${data.message}`,
            tiempo: null,
          });
          if (data.messageT == "S") this.limpiarForm();
          this.$emit("post-enviar-mensaje", {
            mensaje: this.mensaje,
            info: data,
            borrador: this.borrador,
          });

          this.enviando = false;
        } catch (error) {

          this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
          this.enviando = false;
        }
      }
    },

    async savenotif() {
      console.log('Estoy guardando');
      let users = this.mensaje.destinatarios
      let filteredUsers = []
      // Verifica que users esté definido y sea un array
      if (Array.isArray(users)) {
        filteredUsers = users.map(id_usuario => ({ id_usuario }));
      } else {
        console.error("users no está definido o no es un array");
      }
      const fechaActual = new Date();
      const horaActual = fechaActual.toLocaleTimeString('en-GB', {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
      });

      const datanotif = {

        id_colegio: this.datoLogin.id_colegio,
        id_ano_lectivo: this.datoLogin.id_ano_lectivo,
        titulo_notif: 'Mensaje nuevo',
        contenido_notif: 'Tienes un nuevon mensaje recibido de ' + this.datoLogin.nombre_persona,
        id_perfil: this.datoLogin.id_perfil,
        id_usuario: this.datoLogin.id,
        fecha_notif: fechaActual,
        hora_notif: horaActual,
        icon_notif: 'fas fa-envelope-open-text',
        alumnos: filteredUsers,

      };
      try {
        const response1 = await axios.post("/notification/persona/addusernotif/", datanotif);
        this.setEnviarMens({ tipo: `${response1.data.messageT}`, mensaje: `${response1.data.message}`, tiempo: null });
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    obtenerNumero() {
      // console.log(items);
    },

    async enviarWhatsapp() {
      const me = this;
      // eslint-disable-next-line no-unused-vars
      let numero;
      me.$refs.formWhatsapp.validate();

      if (me.$refs.formWhatsapp.validate() == true) {
        if (me.NumeroManual == "") {
          if (me.numeroDestino.length < 9) {
            me.snackbarGlobal = true;
            me.colorsnackbarGlobal = "red";
            me.textAlertGlobal = "El numero debe tener un formato de 9 digitos";
            return;
          } else {
            numero = me.numeroDestino;
          }
        } else {
          if (me.NumeroManual.length < 9) {
            me.snackbarGlobal = true;
            me.colorsnackbarGlobal = "red";
            me.textAlertGlobal = "El numero debe tener un formato de 9 digitos";
            return;
          } else {
            numero = me.NumeroManual;
          }
        }
      }

      try {
        const response = await axios.get(
          `/inicio/mensajeria/enviarWhatsapp/${me.numeroDestino}/${me.MensajeAEnviar} `
        );

        if (response.status == 200) {
          me.mostrarSnackbar = true;
          me.mensajeAlerta = "Se ha enviado un mensaje a Whatsapp";

        }
      } catch (error) {
        console.error(error);
      } finally {
        me.cancelarWhatsapp();
      }
    },

    cancelarWhatsapp() {
      this.MensajeAEnviar = "";
      this.NumeroManual = "";
      this.numeroDestino = "";
    },
  },
  computed: {
    items() {
      return this.destinatarios
        .filter((d) => d.id != sessionStorage.id)
        .map((destinatario) => {
          let desc = `${destinatario.descripcion_perfil} - ${destinatario.apellido_nombre}`;
          const Description =
            desc.length > this.descriptionLimit
              ? desc.slice(0, this.descriptionLimit) + "... "
              : desc;

          return Object.assign({}, destinatario, { Description });
        });
    },
    itemsDestinatariosWhatsapp() {
      return this.destinatarios
        .filter((d) => d.id != sessionStorage.id)
        .map((destinatario) => {
          let desc = `${destinatario.descripcion_perfil} - ${destinatario.apellido_nombre}`;
          const Description =
            desc.length > this.descriptionLimit
              ? desc.slice(0, this.descriptionLimit) + "... "
              : desc;

          return Object.assign({}, destinatario, { Description });
        });
    },
  },
  watch: {
    buscarDestinatarios(val) {
      // Items have already been requested
      if (this.isLoading) return;
      this.isLoading = true;
      this.destinatariosFilter = this.destinatarios.filter(
        (d) =>
          d.apellido_nombre.toLowerCase().indexOf((val || "").toLowerCase()) >
          -1 ||
          d.correo_persona.toLowerCase().indexOf((val || "").toLowerCase()) > -1
      );
      this.isLoading = false;
    },
    // 'mensaje.adjuntos': function(newVal) {

    //   console.log(newVal, "mensaadjuntos");
    // },
  },
  async created() {
    if (this.borrador && this.borrador.adjuntos.length > 0) {
      let files = [];
      for (let index = 0; index < this.borrador.adjuntos.length; index++) {
        const adjunto = this.borrador.adjuntos[index];
        let { data } = await cleanAxios({
          url: `${BUCKET_ORIGIN_SPACE}/${adjunto.uri}`,
          method: "GET",
          responseType: "blob", // important
        });

        files.push(new File([data], adjunto.nombre_original, {type: data.type}));
      }
      this.mensaje.adjuntos = files;
    }
    if (this.mensaje.cuerpo != "")
      this.destinatariosFilter = [...this.destinatarios];
  },
};
</script>
<style scoped>
.classNM .v-text-field__details {
  display: none;
}
</style>